import { Injectable } from '@angular/core';

@Injectable()
export class MainHeaderTruckService {

  veiculo: string;
  nomeMotorista: string;
  nomeCompletoMotorista: string;
  contatoMotorista: string;
  porcBateria: number;
  data: Date;
  constructor() { }

}
